export class NotificationResponse {
  _id: string = "";
  created_at: string = "";
  updated_at: string = "";
  object_type: number = 0;
  object_id: string = "";
  action_type: number = 0;
  status: number = 0;
  title: string = "";
  message: string = "";
  data: string = "";
  image_url: string = "";
  recipient_ids: number[] = [];
  sender_id: number = 0;
  type: number = 0;
  read_at: string = "";
  user_notification: UserNotification = new UserNotification();

  constructor(data?: Partial<NotificationResponse>) {
    Object.assign(this, data);
  }
}

export class UserNotification {
  _id: string = "";
  created_at: string = "";
  updated_at: string = "";
  user_id: number = 0;
  notification_id: string = "";
  deleted_at: string = "";
  name: string = "";
  avatar: string = "";
}

export class NotificationReadStatus {
  total_unread: number = 0;
  total_read: number = 0;
}

export class PayloadFirebaseNotify {
  title: string = "";
  message: string = "";
  data: any;
  object_id: string = "";
  object_type: number = 0;
  action_type: number = 0;
  recipient_ids: number[] = [];
  sender_id: number = 0;
  type: number = 0;
  image_url: string = "";
  push_token: string = "";
  user_notification?: UserNotificationPayload;
  constructor(data?: Partial<PayloadFirebaseNotify>) {
    Object.assign(this, data);
  }
}

export class UserNotificationPayload {
  id: number = 0;
  avatar: string = "";
  name: string = "";
  constructor(data?: Partial<UserNotificationPayload>) {
    Object.assign(this, data);
  }
}
